class BackToTop extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['button']
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(window, 'scroll', this.onScroll.bind(this))
    this.listeners.add(this.els.button.element, 'click', this.onClick.bind(this))

    this.onScroll()
  }

  onScroll () {
    this.toggleAttribute('data-visible', window.scrollY > window.innerHeight)
  }

  onClick () {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }
}

if (!customElements.get('back-to-top')) {
  customElements.define('back-to-top', BackToTop)
}
